export const LAST_ENGAGMENT_PROGESS_KEY = 'last-engagement-progress';
